import React, { useState } from 'react';
import { Box, useMediaQuery, Tooltip, IconButton, Modal } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import LanguageIcon from '@mui/icons-material/Language';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import Notifications from '../shared/notification';
import PreferencesModal from '../shared/PreferencesModal';
import UserDetailsModal from '../shared/UserDetailsModal';
import { useUser } from '../../services/userContext';

const TransferBondLayout = ({ children }) => {
  const { user } = useUser();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);
  const [isUserDetailsModalOpen, setIsUserDetailsModalOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleOpenPreferencesModal = () => {
    setIsPreferencesModalOpen(true);
  };

  const handleClosePreferencesModal = () => {
    setIsPreferencesModalOpen(false);
  };

  const handleOpenUserDetailsModal = () => {
    setIsUserDetailsModalOpen(true);
  };

  const handleCloseUserDetailsModal = () => {
    setIsUserDetailsModalOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexGrow: 0, minHeight: '100vh' }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: '80px',
          backgroundColor: '#F4F4F9',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingY: 1,
          transition: 'width 0.3s ease',
          marginTop: 0,
          marginLeft: 0,
          borderRight: '3px solid #e0e0e0'
         
        }}
      >
        {/* Home Icon */}
        <Tooltip title="Home" placement="right">
          <IconButton
            color="secondary"
            onClick={() => handleNavigation('/TransferBond')}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.3)'
              },
            }}
          >
            <HomeIcon sx={{ fontSize: '2.5rem' }} />
          </IconButton>
        </Tooltip>

        {/* Notifications Icon */}
        <Notifications />

        {/* Settings Icon */}
        <Tooltip title="Contacts and Preferences" placement="right">
          <IconButton
            color="secondary"
            onClick={handleOpenPreferencesModal}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.3)'
              },
            }}
          >
            <ContactPhoneIcon sx={{ fontSize: '2.5rem' }} />
          </IconButton>
        </Tooltip>

        {/* Person Icon */}
        <Tooltip title="User Details" placement="right">
          <IconButton
            color="primary"
            onClick={handleOpenUserDetailsModal}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.3)'
              },
            }}
          >
            <AccountCircleIcon sx={{ fontSize: '2.5rem' }} />
          </IconButton>
        </Tooltip>

        {/* Portal Icon */}
        <Tooltip title="Back to Main Portal" placement="right">
          <IconButton
            color="secondary"
            onClick={() => (window.location.href = process.env.REACT_APP_PORTAL_URL)}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.3)'
              },
            }}
          >
            <LanguageIcon sx={{ fontSize: '2.5rem' }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1, padding: 0 }}>
        {children}
      </Box>

      {/* Preferences Modal */}
      <PreferencesModal
        isOpen={isPreferencesModalOpen}
        onClose={handleClosePreferencesModal}
        agencies={user?.info?.agencyDetails}
      />

      {/* User Details Modal */}
      <UserDetailsModal
        isOpen={isUserDetailsModalOpen}
        onClose={handleCloseUserDetailsModal}
      />
    </Box>
  );
};

export default TransferBondLayout;
